import React, { Component } from "react";
import { connect } from "react-redux";
import UserName from "../../components/UserAccount/UserName";
import Security from "../../components/UserAccount/Security";
import DeleteAccount from "../../components/UserAccount/DeleteAccount";
import { deleteUserAccount } from "../../store/sales/operations";
import { Card, Tabs } from "antd";
import {isCancelingSubscription} from "../../store/sales/selectors";

import {
  getUserEmail,
  getUserFirstName,
  getUserLastName,
  isChangingUserName,
  isChangingPassword,
  userIsLoading
} from "../../store/iam/selectors";
import { changeUserName, changePassword } from "../../store/iam/operations";

const { TabPane } = Tabs;

class UserAccount extends Component {
  constructor(props) {
    super(props);

    this.submitChangeUserNameForm = this.submitChangeUserNameForm.bind(this);
    this.submitChangePassword = this.submitChangePassword.bind(this);
  }

  submitChangeUserNameForm(firstName, lastName) {
    this.props.changeUserName(firstName, lastName);
  }

  submitChangePassword(newPassword) {
    this.props.changePassword(newPassword);
  }

  render() {
    return (
      <div>
        <Card bordered={false}>
          <Tabs className="user-account-tabs" onChange={this.onTabChange} type="card">
            <TabPane tab="Personal information" key="personal-information">
              <UserName
                email={this.props.email}
                firstName={this.props.firstName}
                lastName={this.props.lastName}
                isLoading={this.props.isChangingUserName}
                isLoadingUser={this.props.isLoadingUser}
                onSubmit={this.submitChangeUserNameForm}
              />
            </TabPane>
            <TabPane tab="Security" key="security">
              <Security isLoading={this.props.isChangingPassword} onSubmit={this.submitChangePassword} />
            </TabPane>
            <TabPane tab="Delete account" key="delete-account">
              <DeleteAccount onCancelSubscription={this.props.deleteUserAccount} isCancelingSubscription={this.props.isCancelingSubscription} />
            </TabPane>
          </Tabs>
        </Card>        
      </div>
    );
  }
}

const mapStateToProps = state => ({
  email: getUserEmail(state),
  firstName: getUserFirstName(state),
  lastName: getUserLastName(state),
  isChangingUserName: isChangingUserName(state),
  isChangingPassword: isChangingPassword(state),
  isLoadingUser: userIsLoading(state),
  isCancelingSubscription: isCancelingSubscription(state)
});

export default connect(mapStateToProps, {
  changeUserName,
  changePassword,
  deleteUserAccount
})(UserAccount);
